import { render, staticRenderFns } from "./AppDefaultFooter.vue?vue&type=template&id=24c249be&scoped=true"
import script from "./AppDefaultFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppDefaultFooter.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AppDefaultFooter.vue?vue&type=style&index=0&id=24c249be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c249be",
  null
  
)

export default component.exports